import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { FaTrash, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../roleCrypto";

const API = process.env.REACT_APP_API_URL;
const userRole = getUserRole();

const Casefilelist = () => {
  useEffect(() => {
    document.title = "Case File List | Admin Panel";
    fetchCasefiles();
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [casefiles, setCasefiles] = useState([]);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const navigate = useNavigate();
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  // FETCH
  const fetchCasefiles = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/casefiles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCasefiles(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  // FILTER
  const filteredData = casefiles.filter((item) => {
    const keyword = search.toLowerCase();

    return (
      item.customer_name?.toLowerCase().includes(keyword) ||
      item.customer_contact?.toString().toLowerCase().includes(keyword) ||
      item.case_file_number?.toString().toLowerCase().includes(keyword)
    );
  });

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this case file?"
  );

  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem("token");

    const res = await axios.delete(`${API}/casefiles/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    toast.success(res.data.message || "Deleted successfully");

    // refresh list
    fetchCasefiles();

  } catch (err) {
    console.log(err);
    toast.error("Delete failed");
  }
};

const updateStatus = async (id, newStatus) => {
  try {
    const token = localStorage.getItem("token");

    await axios.put(
      `${API}/casefiles/${id}/status`,
      { status: newStatus },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Status updated");

    // update UI instantly (no reload)
    setCasefiles((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item
      )
    );
  } catch (err) {
    console.log(err);
    toast.error("Status update failed");
  }
};

  return (
    <div className="flex min-h-screen bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50">

      {/* Sidebar */}
      <Sidebar
        isOpen={isOpen}
        toggleSidebar={() => setIsOpen(!isOpen)}
      />

      {/* Main */}
      <div className="flex-1 flex flex-col">

        {/* Header */}
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">

          {/* HEADER SECTION */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">

             <h2 className="text-2xl font-bold">Case Files</h2>

            {/* SEARCH BOX */}
            <div className="w-full md:w-80">
              <label className="text-sm font-semibold text-gray-600 mb-1 block">
                🔍 Search Case Files
              </label>

              <input
                type="text"
                placeholder="Name, Contact, Case File No..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
              />
            </div>

          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            {currentItems.length > 0 ? (
              currentItems.map((item) => (
               <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition border border-gray-100">

              {/* TOP SECTION */}
              <div className="flex justify-between items-start">

                <h3 className="font-bold text-blue-600 text-lg">
                  #{item.case_file_number}
                </h3>

                {/* STATUS BADGE */}
                <span
                  className={`px-3 py-1 text-xs font-semibold rounded-full
                    ${
                      item.status === "Created"
                        ? "bg-blue-100 text-blue-700"
                        : item.status === "Quoted"
                        ? "bg-purple-100 text-purple-700"
                        : item.status === "Invoiced"
                        ? "bg-indigo-100 text-indigo-700"
                        : item.status === "Cancel"
                        ? "bg-red-100 text-red-700"
                        : item.status === "Running"
                        ? "bg-yellow-100 text-yellow-700"
                        : item.status === "Closed"
                        ? "bg-gray-300 text-gray-800"
                        : item.status === "Win"
                        ? "bg-green-100 text-green-700"
                        : item.status === "Loose"
                        ? "bg-orange-100 text-orange-700"
                        : "bg-gray-100 text-gray-600"
                    }
                  `}
                >
                  {item.status || "Unknown"}
                </span>

              </div>

              {/* DETAILS */}
              <div className="mt-3 space-y-2">

                <p className="text-gray-800 font-semibold text-base">
                  <span className="text-gray-500 font-medium">Name:</span>{" "}
                  {item.customer_name}
                </p>

                <p className="text-gray-600">
                  <span className="text-gray-500 font-medium">Contact:</span>{" "}
                  📞 {item.customer_contact}
                </p>

                {item.customer_vat && (
                  <p className="text-gray-600">
                    <span className="text-gray-500 font-medium">VAT:</span>{" "}
                    🧾 {item.customer_vat}
                  </p>
                )}

              </div>

              {/* STATUS EDIT SECTION */}
              <div className="mt-4 border-t pt-3">

                <label className="text-sm font-semibold text-gray-600">
                  Update Status
                </label>

                <select
                  value={item.status || ""}
                  onChange={(e) => updateStatus(item.id, e.target.value)}
                  className="w-full mt-2 px-3 py-2 border rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                  <option value="Created">Created</option>
                  <option value="Quoted">Quoted</option>
                  <option value="Invoiced">Invoiced</option>
                  <option value="Running">Running</option>
                  <option value="Closed">Closed</option>
                  <option value="Win">Win</option>
                  <option value="Loose">Loose</option>
                  <option value="Cancel">Cancel</option>
                </select>

              </div>

              {/* FOOTER ACTIONS */}
              <div className="mt-4 flex justify-end gap-4">
               {userRole !== "subadmin" && (
                <button
                  onClick={() => handleDelete(item.id)}
                  className="text-red-600 hover:text-red-800"
                >
                  <FaTrash size={18} />
                </button>
               )}

                <button
                  onClick={() => navigate(`/casefile-edit/${item.id}`)}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <FaEdit size={18} />
                </button>

              </div>

            </div>
              ))
            ) : (
              <div className="col-span-3 text-center py-16 text-gray-500">
                <div className="text-6xl mb-3">📁</div>
                <p className="text-lg font-medium">
                  No case files found
                </p>
                <p className="text-sm">
                  Try adjusting your search
                </p>
              </div>
            )}

          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-8 gap-2">

              <button
                onClick={() =>
                  setCurrentPage((p) => Math.max(p - 1, 1))
                }
                className="px-4 py-2 bg-white border rounded-lg shadow-sm hover:bg-gray-100"
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-4 py-2 border rounded-lg shadow-sm ${
                    currentPage === i + 1
                      ? "bg-blue-600 text-white"
                      : "bg-white hover:bg-gray-100"
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() =>
                  setCurrentPage((p) =>
                    Math.min(p + 1, totalPages)
                  )
                }
                className="px-4 py-2 bg-white border rounded-lg shadow-sm hover:bg-gray-100"
              >
                Next
              </button>

            </div>
          )}

        </main>
      </div>
    </div>
  );
};

export default Casefilelist;